"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _jsxRuntime = require("react/jsx-runtime");
var _helpers = require("../../../utils/helpers");
var _filterCardWrapper = require("./filterCardWrapper.style");
function FilterCardWrapper(_ref) {
  let {
    title,
    hasRadio = false,
    expanded = false,
    header,
    body,
    footer,
    onCardToggle
  } = _ref;
  const testId = (0, _helpers.kebabCase)(title);
  return (0, _jsxRuntime.jsxs)(_filterCardWrapper.Components.FilterCardWrapperContainer, {
    children: [(0, _jsxRuntime.jsxs)(_filterCardWrapper.Components.FilterCardWrapperHeader, (0, _extends2["default"])({
      onClick: () => !hasRadio && onCardToggle(title),
      "data-testId": "filter-bar-title-".concat(testId)
    }, {
      children: [(0, _jsxRuntime.jsx)(_filterCardWrapper.Components.FilterCardWrapperHeaderTitle, {
        children: (0, _jsxRuntime.jsx)("p", {
          children: (0, _jsxRuntime.jsx)("strong", {
            children: title
          })
        })
      }), !hasRadio && (0, _jsxRuntime.jsx)(_filterCardWrapper.Components.FilterCardWrapperIcon, {
        name: expanded ? 'chevron-up' : 'chevron-down',
        size: "24"
      })]
    })), expanded && (0, _jsxRuntime.jsxs)(_filterCardWrapper.Components.FilterCardWrapperContent, {
      children: [(0, _jsxRuntime.jsx)(_filterCardWrapper.Components.FilterCardWrapperContentHeader, (0, _extends2["default"])({
        "data-testId": "filter-bar-card-header-".concat(testId)
      }, {
        children: header
      })), (0, _jsxRuntime.jsx)(_filterCardWrapper.Components.FilterCardWrapperContentBody, (0, _extends2["default"])({
        "data-testId": "filter-bar-card-body-".concat(testId)
      }, {
        children: body
      })), footer && (0, _jsxRuntime.jsx)(_filterCardWrapper.Components.FilterCardWrapperContentFooter, (0, _extends2["default"])({
        "data-testId": "filter-bar-card-footer-".concat(testId)
      }, {
        children: footer
      }))]
    })]
  });
}
var _default = exports["default"] = FilterCardWrapper;